import React from 'react';
import {Link} from 'react-router-dom';

export default class CalcFooter extends React.Component {
    constructor(props) {
        super(props);
    }

    handleActivePageChange = (new_value) => {
        this.props.onActivePageChange(new_value);
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.active_page === 0 &&
                    <div className={`calc-footer-flex ${this.props.className ?? ''}`}>
                        <Link to="/" className="return-footer-button">戻る</Link>
                        <button className="next-footer-button" disabled={this.props.next_disabled} onClick={() => this.handleActivePageChange(this.props.is_date_select ? 2 : 1)}>次へ</button>
                    </div>
                }
                {
                    this.props.active_page === 1 &&
                    <div className={`calc-footer-flex ${this.props.className ?? ''}`}>
                        <button className="return-footer-button" onClick={() => this.handleActivePageChange(0)}>戻る</button>
                        <button className="next-footer-button" disabled={this.props.next_disabled} onClick={() => this.handleActivePageChange(2)}>次へ</button>
                    </div>
                }
                {
                    this.props.active_page === 2 &&
                    <div className={`calc-footer-flex ${this.props.className ?? ''}`}>
                        <button className="return-footer-button" onClick={() => this.handleActivePageChange(this.props.is_date_select ? 0 : 1)}>戻る</button>
                        <Link to="/" className="next-footer-button">トップページへ</Link>
                    </div>
                }
            </React.Fragment>
        );
    }
}